export const CONFIRM_CANCEL_EVENT = 'confirm-cancel-event';
